module.exports = __webpack_public_path__ + "img/disaster_relief-gallery-3.98fd74a0.jpg";